import React from 'react'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'

import './style.css.scss'

const KnownLead = (props) => {
  const {lead, onLeadUnknownClick} = props
  const leadName = `${lead.name || ""} ${lead.last_name || ""}`.trim()

  return (
    <div className="known-lead-container">
      <div className="known-lead-greeting">
        <div>{props.getTranslation(TRANSLATION_VALUE_KEYS.hi, { leadName })},</div>
        <div>{props.getTranslation(TRANSLATION_VALUE_KEYS.clickSend)}</div>
      </div>
      <span
        className="unknown-lead-link"
        onClick={onLeadUnknownClick}>
        {props.getTranslation(TRANSLATION_VALUE_KEYS.notLeadName,{ leadName })}
      </span>
    </div>
  )
}

KnownLead.propTypes = {
  lead: PropTypes.object.isRequired,
  onLeadUnknownClick: PropTypes.func.isRequired
}

export default withTranslation(TRANSLATION_KEYS.knownLead)(KnownLead)
